/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompromisedDevice,
  DomainName,
  MonitoredDomain,
  PaginatedCompromisedDeviceList,
  PaginatedDomainNameList,
  PaginatedMonitoredDomainList,
  PaginatedPublicLeakList,
  PaginatedServiceNameList,
  PaginatedSourceList,
  PaginatedStealerLeakList,
  PatchedCompromisedDevice,
  PatchedDomainName,
  PatchedMonitoredDomain,
  PatchedPublicLeak,
  PatchedServiceName,
  PatchedSource,
  PatchedStealerLeak,
  PublicLeak,
  ServiceName,
  Source,
  StealerLeak,
} from '../models/index';
import {
    CompromisedDeviceFromJSON,
    CompromisedDeviceToJSON,
    DomainNameFromJSON,
    DomainNameToJSON,
    MonitoredDomainFromJSON,
    MonitoredDomainToJSON,
    PaginatedCompromisedDeviceListFromJSON,
    PaginatedCompromisedDeviceListToJSON,
    PaginatedDomainNameListFromJSON,
    PaginatedDomainNameListToJSON,
    PaginatedMonitoredDomainListFromJSON,
    PaginatedMonitoredDomainListToJSON,
    PaginatedPublicLeakListFromJSON,
    PaginatedPublicLeakListToJSON,
    PaginatedServiceNameListFromJSON,
    PaginatedServiceNameListToJSON,
    PaginatedSourceListFromJSON,
    PaginatedSourceListToJSON,
    PaginatedStealerLeakListFromJSON,
    PaginatedStealerLeakListToJSON,
    PatchedCompromisedDeviceFromJSON,
    PatchedCompromisedDeviceToJSON,
    PatchedDomainNameFromJSON,
    PatchedDomainNameToJSON,
    PatchedMonitoredDomainFromJSON,
    PatchedMonitoredDomainToJSON,
    PatchedPublicLeakFromJSON,
    PatchedPublicLeakToJSON,
    PatchedServiceNameFromJSON,
    PatchedServiceNameToJSON,
    PatchedSourceFromJSON,
    PatchedSourceToJSON,
    PatchedStealerLeakFromJSON,
    PatchedStealerLeakToJSON,
    PublicLeakFromJSON,
    PublicLeakToJSON,
    ServiceNameFromJSON,
    ServiceNameToJSON,
    SourceFromJSON,
    SourceToJSON,
    StealerLeakFromJSON,
    StealerLeakToJSON,
} from '../models/index';

export interface CompromisedDevicesListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
}

export interface CompromisedDevicesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsCompromisedDevicesCreateRequest {
    teamSlug: string;
    compromisedDevice?: Omit<CompromisedDevice, 'id'|'created_at'|'updated_at'|'leaks'|'leaks_count'>;
}

export interface CredentialsCompromisedDevicesDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsCompromisedDevicesLeaksRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsCompromisedDevicesPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedCompromisedDevice?: Omit<PatchedCompromisedDevice, 'id'|'created_at'|'updated_at'|'leaks'|'leaks_count'>;
}

export interface CredentialsCompromisedDevicesStatisticsRetrieveRequest {
    teamSlug: string;
}

export interface CredentialsCompromisedDevicesUpdateRequest {
    id: string;
    teamSlug: string;
    compromisedDevice?: Omit<CompromisedDevice, 'id'|'created_at'|'updated_at'|'leaks'|'leaks_count'>;
}

export interface CredentialsDomainsDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsDomainsLeaksRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsDomainsPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedDomainName?: Omit<PatchedDomainName, 'id'|'created_at'|'updated_at'|'leaks_count'>;
}

export interface CredentialsDomainsUpdateRequest {
    id: string;
    teamSlug: string;
    domainName: Omit<DomainName, 'id'|'created_at'|'updated_at'|'leaks_count'>;
}

export interface CredentialsMonitoredDomainsCredentialsRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsMonitoredDomainsDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsMonitoredDomainsPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedMonitoredDomain?: Omit<PatchedMonitoredDomain, 'id'|'tag_list'|'created_at'|'updated_at'>;
}

export interface CredentialsMonitoredDomainsUpdateRequest {
    id: string;
    teamSlug: string;
    monitoredDomain: Omit<MonitoredDomain, 'id'|'tag_list'|'created_at'|'updated_at'>;
}

export interface CredentialsPublicLeaksCreateRequest {
    teamSlug: string;
    publicLeak: Omit<PublicLeak, 'id'|'source_name'|'created_at'|'updated_at'>;
}

export interface CredentialsPublicLeaksDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsPublicLeaksPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedPublicLeak?: Omit<PatchedPublicLeak, 'id'|'source_name'|'created_at'|'updated_at'>;
}

export interface CredentialsPublicLeaksStatisticsRetrieveRequest {
    teamSlug: string;
}

export interface CredentialsPublicLeaksUpdateRequest {
    id: string;
    teamSlug: string;
    publicLeak: Omit<PublicLeak, 'id'|'source_name'|'created_at'|'updated_at'>;
}

export interface CredentialsSearchRequest {
    domain: string;
    teamSlug: string;
    limit?: number;
}

export interface CredentialsServicesDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsServicesLeaksRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsServicesPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedServiceName?: Omit<PatchedServiceName, 'id'|'created_at'|'updated_at'|'leaks_count'>;
}

export interface CredentialsServicesUpdateRequest {
    id: string;
    teamSlug: string;
    serviceName: Omit<ServiceName, 'id'|'created_at'|'updated_at'|'leaks_count'>;
}

export interface CredentialsSourcesCreateRequest {
    teamSlug: string;
    source: Omit<Source, 'id'|'created_at'|'updated_at'>;
}

export interface CredentialsSourcesDestroyRequest {
    id: number;
    teamSlug: string;
}

export interface CredentialsSourcesPartialUpdateRequest {
    id: number;
    teamSlug: string;
    patchedSource?: Omit<PatchedSource, 'id'|'created_at'|'updated_at'>;
}

export interface CredentialsSourcesUpdateRequest {
    id: number;
    teamSlug: string;
    source: Omit<Source, 'id'|'created_at'|'updated_at'>;
}

export interface CredentialsStealerLeaksCreateRequest {
    teamSlug: string;
    stealerLeak: Omit<StealerLeak, 'id'|'created_at'|'updated_at'|'device_info'|'domain_name'|'service_name'|'assigned_to_details'>;
}

export interface CredentialsStealerLeaksDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface CredentialsStealerLeaksPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedStealerLeak?: Omit<PatchedStealerLeak, 'id'|'created_at'|'updated_at'|'device_info'|'domain_name'|'service_name'|'assigned_to_details'>;
}

export interface CredentialsStealerLeaksStatisticsRetrieveRequest {
    teamSlug: string;
}

export interface CredentialsStealerLeaksUpdateRequest {
    id: string;
    teamSlug: string;
    stealerLeak: Omit<StealerLeak, 'id'|'created_at'|'updated_at'|'device_info'|'domain_name'|'service_name'|'assigned_to_details'>;
}

export interface DomainsCreateRequest {
    teamSlug: string;
    domainName: Omit<DomainName, 'id'|'created_at'|'updated_at'|'leaks_count'>;
}

export interface DomainsList2Request {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface DomainsRetrieve2Request {
    id: string;
    teamSlug: string;
}

export interface MonitoredDomainsCreateRequest {
    teamSlug: string;
    monitoredDomain: Omit<MonitoredDomain, 'id'|'tag_list'|'created_at'|'updated_at'>;
}

export interface MonitoredDomainsImportCredentialsRequest {
    domain: string;
    teamSlug: string;
    monitoredDomain: Omit<MonitoredDomain, 'id'|'tag_list'|'created_at'|'updated_at'>;
    limit?: number;
    owner?: string;
}

export interface MonitoredDomainsListRequest {
    teamSlug: string;
    isActive?: boolean;
    limit?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    tag?: string;
}

export interface MonitoredDomainsRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface PublicLeaksListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    source?: string;
}

export interface PublicLeaksRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface ServicesCreateRequest {
    teamSlug: string;
    serviceName: Omit<ServiceName, 'id'|'created_at'|'updated_at'|'leaks_count'>;
}

export interface ServicesListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface ServicesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface SourcesListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface SourcesRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface StealerLeaksListRequest {
    teamSlug: string;
    assignedTo?: number;
    deviceId?: number;
    domainName?: string;
    hasDevice?: string;
    isMobile?: boolean;
    limit?: number;
    ordering?: string;
    owner?: StealerLeaksListOwnerEnum;
    page?: number;
    pageSize?: number;
    readed?: boolean;
    search?: string;
    serviceName?: string;
    severity?: StealerLeaksListSeverityEnum;
    status?: StealerLeaksListStatusEnum;
    twoFaStatus?: StealerLeaksListTwoFaStatusEnum;
    validity?: StealerLeaksListValidityEnum;
}

export interface StealerLeaksRetrieveRequest {
    id: string;
    teamSlug: string;
}

/**
 * 
 */
export class CredentialsApi extends runtime.BaseAPI {

    /**
     */
    async compromisedDevicesListRaw(requestParameters: CompromisedDevicesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedCompromisedDeviceList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling compromisedDevicesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedCompromisedDeviceListFromJSON(jsonValue));
    }

    /**
     */
    async compromisedDevicesList(requestParameters: CompromisedDevicesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedCompromisedDeviceList> {
        const response = await this.compromisedDevicesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async compromisedDevicesRetrieveRaw(requestParameters: CompromisedDevicesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompromisedDevice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling compromisedDevicesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling compromisedDevicesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompromisedDeviceFromJSON(jsonValue));
    }

    /**
     */
    async compromisedDevicesRetrieve(requestParameters: CompromisedDevicesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompromisedDevice> {
        const response = await this.compromisedDevicesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsCompromisedDevicesCreateRaw(requestParameters: CredentialsCompromisedDevicesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompromisedDevice>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsCompromisedDevicesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompromisedDeviceToJSON(requestParameters['compromisedDevice']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompromisedDeviceFromJSON(jsonValue));
    }

    /**
     */
    async credentialsCompromisedDevicesCreate(requestParameters: CredentialsCompromisedDevicesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompromisedDevice> {
        const response = await this.credentialsCompromisedDevicesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsCompromisedDevicesDestroyRaw(requestParameters: CredentialsCompromisedDevicesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsCompromisedDevicesDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsCompromisedDevicesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async credentialsCompromisedDevicesDestroy(requestParameters: CredentialsCompromisedDevicesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsCompromisedDevicesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get all leaks for a specific compromised device
     */
    async credentialsCompromisedDevicesLeaksRetrieveRaw(requestParameters: CredentialsCompromisedDevicesLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompromisedDevice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsCompromisedDevicesLeaksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsCompromisedDevicesLeaksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/{id}/leaks/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompromisedDeviceFromJSON(jsonValue));
    }

    /**
     * Get all leaks for a specific compromised device
     */
    async credentialsCompromisedDevicesLeaksRetrieve(requestParameters: CredentialsCompromisedDevicesLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompromisedDevice> {
        const response = await this.credentialsCompromisedDevicesLeaksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsCompromisedDevicesPartialUpdateRaw(requestParameters: CredentialsCompromisedDevicesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompromisedDevice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsCompromisedDevicesPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsCompromisedDevicesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedCompromisedDeviceToJSON(requestParameters['patchedCompromisedDevice']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompromisedDeviceFromJSON(jsonValue));
    }

    /**
     */
    async credentialsCompromisedDevicesPartialUpdate(requestParameters: CredentialsCompromisedDevicesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompromisedDevice> {
        const response = await this.credentialsCompromisedDevicesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about compromised devices
     */
    async credentialsCompromisedDevicesStatisticsRetrieveRaw(requestParameters: CredentialsCompromisedDevicesStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompromisedDevice>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsCompromisedDevicesStatisticsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/statistics/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompromisedDeviceFromJSON(jsonValue));
    }

    /**
     * Get statistics about compromised devices
     */
    async credentialsCompromisedDevicesStatisticsRetrieve(requestParameters: CredentialsCompromisedDevicesStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompromisedDevice> {
        const response = await this.credentialsCompromisedDevicesStatisticsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsCompromisedDevicesUpdateRaw(requestParameters: CredentialsCompromisedDevicesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompromisedDevice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsCompromisedDevicesUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsCompromisedDevicesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/compromised-devices/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompromisedDeviceToJSON(requestParameters['compromisedDevice']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompromisedDeviceFromJSON(jsonValue));
    }

    /**
     */
    async credentialsCompromisedDevicesUpdate(requestParameters: CredentialsCompromisedDevicesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompromisedDevice> {
        const response = await this.credentialsCompromisedDevicesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsDomainsDestroyRaw(requestParameters: CredentialsDomainsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsDomainsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsDomainsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async credentialsDomainsDestroy(requestParameters: CredentialsDomainsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsDomainsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get all leaks for a specific domain
     */
    async credentialsDomainsLeaksRetrieveRaw(requestParameters: CredentialsDomainsLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsDomainsLeaksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsDomainsLeaksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/{id}/leaks/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainNameFromJSON(jsonValue));
    }

    /**
     * Get all leaks for a specific domain
     */
    async credentialsDomainsLeaksRetrieve(requestParameters: CredentialsDomainsLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainName> {
        const response = await this.credentialsDomainsLeaksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsDomainsPartialUpdateRaw(requestParameters: CredentialsDomainsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsDomainsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsDomainsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDomainNameToJSON(requestParameters['patchedDomainName']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainNameFromJSON(jsonValue));
    }

    /**
     */
    async credentialsDomainsPartialUpdate(requestParameters: CredentialsDomainsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainName> {
        const response = await this.credentialsDomainsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsDomainsUpdateRaw(requestParameters: CredentialsDomainsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsDomainsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsDomainsUpdate().'
            );
        }

        if (requestParameters['domainName'] == null) {
            throw new runtime.RequiredError(
                'domainName',
                'Required parameter "domainName" was null or undefined when calling credentialsDomainsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DomainNameToJSON(requestParameters['domainName']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainNameFromJSON(jsonValue));
    }

    /**
     */
    async credentialsDomainsUpdate(requestParameters: CredentialsDomainsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainName> {
        const response = await this.credentialsDomainsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve credentials for a monitored domain directly from the leaks database.
     */
    async credentialsMonitoredDomainsCredentialsRetrieveRaw(requestParameters: CredentialsMonitoredDomainsCredentialsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsMonitoredDomainsCredentialsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsMonitoredDomainsCredentialsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/{id}/credentials/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieve credentials for a monitored domain directly from the leaks database.
     */
    async credentialsMonitoredDomainsCredentialsRetrieve(requestParameters: CredentialsMonitoredDomainsCredentialsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsMonitoredDomainsCredentialsRetrieveRaw(requestParameters, initOverrides);
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async credentialsMonitoredDomainsDestroyRaw(requestParameters: CredentialsMonitoredDomainsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsMonitoredDomainsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsMonitoredDomainsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async credentialsMonitoredDomainsDestroy(requestParameters: CredentialsMonitoredDomainsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsMonitoredDomainsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async credentialsMonitoredDomainsPartialUpdateRaw(requestParameters: CredentialsMonitoredDomainsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MonitoredDomain>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsMonitoredDomainsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsMonitoredDomainsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedMonitoredDomainToJSON(requestParameters['patchedMonitoredDomain']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MonitoredDomainFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async credentialsMonitoredDomainsPartialUpdate(requestParameters: CredentialsMonitoredDomainsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MonitoredDomain> {
        const response = await this.credentialsMonitoredDomainsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async credentialsMonitoredDomainsUpdateRaw(requestParameters: CredentialsMonitoredDomainsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MonitoredDomain>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsMonitoredDomainsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsMonitoredDomainsUpdate().'
            );
        }

        if (requestParameters['monitoredDomain'] == null) {
            throw new runtime.RequiredError(
                'monitoredDomain',
                'Required parameter "monitoredDomain" was null or undefined when calling credentialsMonitoredDomainsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MonitoredDomainToJSON(requestParameters['monitoredDomain']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MonitoredDomainFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async credentialsMonitoredDomainsUpdate(requestParameters: CredentialsMonitoredDomainsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MonitoredDomain> {
        const response = await this.credentialsMonitoredDomainsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsPublicLeaksCreateRaw(requestParameters: CredentialsPublicLeaksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsPublicLeaksCreate().'
            );
        }

        if (requestParameters['publicLeak'] == null) {
            throw new runtime.RequiredError(
                'publicLeak',
                'Required parameter "publicLeak" was null or undefined when calling credentialsPublicLeaksCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicLeakToJSON(requestParameters['publicLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicLeakFromJSON(jsonValue));
    }

    /**
     */
    async credentialsPublicLeaksCreate(requestParameters: CredentialsPublicLeaksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicLeak> {
        const response = await this.credentialsPublicLeaksCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsPublicLeaksDestroyRaw(requestParameters: CredentialsPublicLeaksDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsPublicLeaksDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsPublicLeaksDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async credentialsPublicLeaksDestroy(requestParameters: CredentialsPublicLeaksDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsPublicLeaksDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async credentialsPublicLeaksPartialUpdateRaw(requestParameters: CredentialsPublicLeaksPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsPublicLeaksPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsPublicLeaksPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPublicLeakToJSON(requestParameters['patchedPublicLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicLeakFromJSON(jsonValue));
    }

    /**
     */
    async credentialsPublicLeaksPartialUpdate(requestParameters: CredentialsPublicLeaksPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicLeak> {
        const response = await this.credentialsPublicLeaksPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about public leaks
     */
    async credentialsPublicLeaksStatisticsRetrieveRaw(requestParameters: CredentialsPublicLeaksStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsPublicLeaksStatisticsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/statistics/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicLeakFromJSON(jsonValue));
    }

    /**
     * Get statistics about public leaks
     */
    async credentialsPublicLeaksStatisticsRetrieve(requestParameters: CredentialsPublicLeaksStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicLeak> {
        const response = await this.credentialsPublicLeaksStatisticsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsPublicLeaksUpdateRaw(requestParameters: CredentialsPublicLeaksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsPublicLeaksUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsPublicLeaksUpdate().'
            );
        }

        if (requestParameters['publicLeak'] == null) {
            throw new runtime.RequiredError(
                'publicLeak',
                'Required parameter "publicLeak" was null or undefined when calling credentialsPublicLeaksUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PublicLeakToJSON(requestParameters['publicLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicLeakFromJSON(jsonValue));
    }

    /**
     */
    async credentialsPublicLeaksUpdate(requestParameters: CredentialsPublicLeaksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicLeak> {
        const response = await this.credentialsPublicLeaksUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for credentials in the remote database by domain name.
     */
    async credentialsSearchRaw(requestParameters: CredentialsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling credentialsSearch().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/search/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Search for credentials in the remote database by domain name.
     */
    async credentialsSearch(requestParameters: CredentialsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsSearchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async credentialsServicesDestroyRaw(requestParameters: CredentialsServicesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsServicesDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsServicesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async credentialsServicesDestroy(requestParameters: CredentialsServicesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsServicesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get all leaks for a specific service
     */
    async credentialsServicesLeaksRetrieveRaw(requestParameters: CredentialsServicesLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsServicesLeaksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsServicesLeaksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/{id}/leaks/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceNameFromJSON(jsonValue));
    }

    /**
     * Get all leaks for a specific service
     */
    async credentialsServicesLeaksRetrieve(requestParameters: CredentialsServicesLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceName> {
        const response = await this.credentialsServicesLeaksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsServicesPartialUpdateRaw(requestParameters: CredentialsServicesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsServicesPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsServicesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedServiceNameToJSON(requestParameters['patchedServiceName']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceNameFromJSON(jsonValue));
    }

    /**
     */
    async credentialsServicesPartialUpdate(requestParameters: CredentialsServicesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceName> {
        const response = await this.credentialsServicesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsServicesUpdateRaw(requestParameters: CredentialsServicesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsServicesUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsServicesUpdate().'
            );
        }

        if (requestParameters['serviceName'] == null) {
            throw new runtime.RequiredError(
                'serviceName',
                'Required parameter "serviceName" was null or undefined when calling credentialsServicesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceNameToJSON(requestParameters['serviceName']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceNameFromJSON(jsonValue));
    }

    /**
     */
    async credentialsServicesUpdate(requestParameters: CredentialsServicesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceName> {
        const response = await this.credentialsServicesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsSourcesCreateRaw(requestParameters: CredentialsSourcesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Source>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsSourcesCreate().'
            );
        }

        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling credentialsSourcesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/sources/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceToJSON(requestParameters['source']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SourceFromJSON(jsonValue));
    }

    /**
     */
    async credentialsSourcesCreate(requestParameters: CredentialsSourcesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Source> {
        const response = await this.credentialsSourcesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsSourcesDestroyRaw(requestParameters: CredentialsSourcesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsSourcesDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsSourcesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/sources/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async credentialsSourcesDestroy(requestParameters: CredentialsSourcesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsSourcesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async credentialsSourcesPartialUpdateRaw(requestParameters: CredentialsSourcesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Source>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsSourcesPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsSourcesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/sources/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedSourceToJSON(requestParameters['patchedSource']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SourceFromJSON(jsonValue));
    }

    /**
     */
    async credentialsSourcesPartialUpdate(requestParameters: CredentialsSourcesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Source> {
        const response = await this.credentialsSourcesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsSourcesUpdateRaw(requestParameters: CredentialsSourcesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Source>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsSourcesUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsSourcesUpdate().'
            );
        }

        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling credentialsSourcesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/sources/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SourceToJSON(requestParameters['source']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SourceFromJSON(jsonValue));
    }

    /**
     */
    async credentialsSourcesUpdate(requestParameters: CredentialsSourcesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Source> {
        const response = await this.credentialsSourcesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsStealerLeaksCreateRaw(requestParameters: CredentialsStealerLeaksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StealerLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsStealerLeaksCreate().'
            );
        }

        if (requestParameters['stealerLeak'] == null) {
            throw new runtime.RequiredError(
                'stealerLeak',
                'Required parameter "stealerLeak" was null or undefined when calling credentialsStealerLeaksCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StealerLeakToJSON(requestParameters['stealerLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StealerLeakFromJSON(jsonValue));
    }

    /**
     */
    async credentialsStealerLeaksCreate(requestParameters: CredentialsStealerLeaksCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StealerLeak> {
        const response = await this.credentialsStealerLeaksCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsStealerLeaksDestroyRaw(requestParameters: CredentialsStealerLeaksDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsStealerLeaksDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsStealerLeaksDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async credentialsStealerLeaksDestroy(requestParameters: CredentialsStealerLeaksDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.credentialsStealerLeaksDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async credentialsStealerLeaksPartialUpdateRaw(requestParameters: CredentialsStealerLeaksPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StealerLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsStealerLeaksPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsStealerLeaksPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedStealerLeakToJSON(requestParameters['patchedStealerLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StealerLeakFromJSON(jsonValue));
    }

    /**
     */
    async credentialsStealerLeaksPartialUpdate(requestParameters: CredentialsStealerLeaksPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StealerLeak> {
        const response = await this.credentialsStealerLeaksPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about stealer leaks
     */
    async credentialsStealerLeaksStatisticsRetrieveRaw(requestParameters: CredentialsStealerLeaksStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StealerLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsStealerLeaksStatisticsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/statistics/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StealerLeakFromJSON(jsonValue));
    }

    /**
     * Get statistics about stealer leaks
     */
    async credentialsStealerLeaksStatisticsRetrieve(requestParameters: CredentialsStealerLeaksStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StealerLeak> {
        const response = await this.credentialsStealerLeaksStatisticsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async credentialsStealerLeaksUpdateRaw(requestParameters: CredentialsStealerLeaksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StealerLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialsStealerLeaksUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialsStealerLeaksUpdate().'
            );
        }

        if (requestParameters['stealerLeak'] == null) {
            throw new runtime.RequiredError(
                'stealerLeak',
                'Required parameter "stealerLeak" was null or undefined when calling credentialsStealerLeaksUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StealerLeakToJSON(requestParameters['stealerLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StealerLeakFromJSON(jsonValue));
    }

    /**
     */
    async credentialsStealerLeaksUpdate(requestParameters: CredentialsStealerLeaksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StealerLeak> {
        const response = await this.credentialsStealerLeaksUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async domainsCreateRaw(requestParameters: DomainsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainName>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling domainsCreate().'
            );
        }

        if (requestParameters['domainName'] == null) {
            throw new runtime.RequiredError(
                'domainName',
                'Required parameter "domainName" was null or undefined when calling domainsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DomainNameToJSON(requestParameters['domainName']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainNameFromJSON(jsonValue));
    }

    /**
     */
    async domainsCreate(requestParameters: DomainsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainName> {
        const response = await this.domainsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async domainsList2Raw(requestParameters: DomainsList2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDomainNameList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling domainsList2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDomainNameListFromJSON(jsonValue));
    }

    /**
     */
    async domainsList2(requestParameters: DomainsList2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDomainNameList> {
        const response = await this.domainsList2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async domainsRetrieve2Raw(requestParameters: DomainsRetrieve2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling domainsRetrieve2().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling domainsRetrieve2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainNameFromJSON(jsonValue));
    }

    /**
     */
    async domainsRetrieve2(requestParameters: DomainsRetrieve2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainName> {
        const response = await this.domainsRetrieve2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async monitoredDomainsCreateRaw(requestParameters: MonitoredDomainsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MonitoredDomain>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling monitoredDomainsCreate().'
            );
        }

        if (requestParameters['monitoredDomain'] == null) {
            throw new runtime.RequiredError(
                'monitoredDomain',
                'Required parameter "monitoredDomain" was null or undefined when calling monitoredDomainsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MonitoredDomainToJSON(requestParameters['monitoredDomain']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MonitoredDomainFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async monitoredDomainsCreate(requestParameters: MonitoredDomainsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MonitoredDomain> {
        const response = await this.monitoredDomainsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Import credentials for a domain into StealerLeak model.
     */
    async monitoredDomainsImportCredentialsRaw(requestParameters: MonitoredDomainsImportCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MonitoredDomain>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling monitoredDomainsImportCredentials().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling monitoredDomainsImportCredentials().'
            );
        }

        if (requestParameters['monitoredDomain'] == null) {
            throw new runtime.RequiredError(
                'monitoredDomain',
                'Required parameter "monitoredDomain" was null or undefined when calling monitoredDomainsImportCredentials().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/import_credentials/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MonitoredDomainToJSON(requestParameters['monitoredDomain']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MonitoredDomainFromJSON(jsonValue));
    }

    /**
     * Import credentials for a domain into StealerLeak model.
     */
    async monitoredDomainsImportCredentials(requestParameters: MonitoredDomainsImportCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MonitoredDomain> {
        const response = await this.monitoredDomainsImportCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async monitoredDomainsListRaw(requestParameters: MonitoredDomainsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedMonitoredDomainList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling monitoredDomainsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['tag'] != null) {
            queryParameters['tag'] = requestParameters['tag'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedMonitoredDomainListFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async monitoredDomainsList(requestParameters: MonitoredDomainsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedMonitoredDomainList> {
        const response = await this.monitoredDomainsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async monitoredDomainsRetrieveRaw(requestParameters: MonitoredDomainsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MonitoredDomain>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling monitoredDomainsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling monitoredDomainsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/monitored-domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MonitoredDomainFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing monitored domains and searching credentials.
     */
    async monitoredDomainsRetrieve(requestParameters: MonitoredDomainsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MonitoredDomain> {
        const response = await this.monitoredDomainsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async publicLeaksListRaw(requestParameters: PublicLeaksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPublicLeakList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling publicLeaksList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPublicLeakListFromJSON(jsonValue));
    }

    /**
     */
    async publicLeaksList(requestParameters: PublicLeaksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPublicLeakList> {
        const response = await this.publicLeaksListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async publicLeaksRetrieveRaw(requestParameters: PublicLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling publicLeaksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling publicLeaksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/public-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicLeakFromJSON(jsonValue));
    }

    /**
     */
    async publicLeaksRetrieve(requestParameters: PublicLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicLeak> {
        const response = await this.publicLeaksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async servicesCreateRaw(requestParameters: ServicesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceName>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling servicesCreate().'
            );
        }

        if (requestParameters['serviceName'] == null) {
            throw new runtime.RequiredError(
                'serviceName',
                'Required parameter "serviceName" was null or undefined when calling servicesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceNameToJSON(requestParameters['serviceName']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceNameFromJSON(jsonValue));
    }

    /**
     */
    async servicesCreate(requestParameters: ServicesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceName> {
        const response = await this.servicesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async servicesListRaw(requestParameters: ServicesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedServiceNameList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling servicesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedServiceNameListFromJSON(jsonValue));
    }

    /**
     */
    async servicesList(requestParameters: ServicesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedServiceNameList> {
        const response = await this.servicesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async servicesRetrieveRaw(requestParameters: ServicesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceName>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling servicesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling servicesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/services/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceNameFromJSON(jsonValue));
    }

    /**
     */
    async servicesRetrieve(requestParameters: ServicesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceName> {
        const response = await this.servicesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sourcesListRaw(requestParameters: SourcesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSourceList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling sourcesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/sources/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSourceListFromJSON(jsonValue));
    }

    /**
     */
    async sourcesList(requestParameters: SourcesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSourceList> {
        const response = await this.sourcesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sourcesRetrieveRaw(requestParameters: SourcesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Source>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sourcesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling sourcesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/sources/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SourceFromJSON(jsonValue));
    }

    /**
     */
    async sourcesRetrieve(requestParameters: SourcesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Source> {
        const response = await this.sourcesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async stealerLeaksListRaw(requestParameters: StealerLeaksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedStealerLeakList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling stealerLeaksList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['deviceId'] != null) {
            queryParameters['device_id'] = requestParameters['deviceId'];
        }

        if (requestParameters['domainName'] != null) {
            queryParameters['domain_name'] = requestParameters['domainName'];
        }

        if (requestParameters['hasDevice'] != null) {
            queryParameters['has_device'] = requestParameters['hasDevice'];
        }

        if (requestParameters['isMobile'] != null) {
            queryParameters['is_mobile'] = requestParameters['isMobile'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['readed'] != null) {
            queryParameters['readed'] = requestParameters['readed'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceName'] != null) {
            queryParameters['service_name'] = requestParameters['serviceName'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['twoFaStatus'] != null) {
            queryParameters['two_fa_status'] = requestParameters['twoFaStatus'];
        }

        if (requestParameters['validity'] != null) {
            queryParameters['validity'] = requestParameters['validity'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedStealerLeakListFromJSON(jsonValue));
    }

    /**
     */
    async stealerLeaksList(requestParameters: StealerLeaksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedStealerLeakList> {
        const response = await this.stealerLeaksListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async stealerLeaksRetrieveRaw(requestParameters: StealerLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StealerLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling stealerLeaksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling stealerLeaksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/credentials/{team_slug}/stealer-leaks/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StealerLeakFromJSON(jsonValue));
    }

    /**
     */
    async stealerLeaksRetrieve(requestParameters: StealerLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StealerLeak> {
        const response = await this.stealerLeaksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const StealerLeaksListOwnerEnum = {
    Customer: 'customer',
    Employee: 'employee'
} as const;
export type StealerLeaksListOwnerEnum = typeof StealerLeaksListOwnerEnum[keyof typeof StealerLeaksListOwnerEnum];
/**
 * @export
 */
export const StealerLeaksListSeverityEnum = {
    Critical: 'critical',
    High: 'high',
    Info: 'info',
    Low: 'low',
    Medium: 'medium'
} as const;
export type StealerLeaksListSeverityEnum = typeof StealerLeaksListSeverityEnum[keyof typeof StealerLeaksListSeverityEnum];
/**
 * @export
 */
export const StealerLeaksListStatusEnum = {
    Duplicate: 'duplicate',
    FalsePositive: 'false_positive',
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved',
    Retest: 'retest'
} as const;
export type StealerLeaksListStatusEnum = typeof StealerLeaksListStatusEnum[keyof typeof StealerLeaksListStatusEnum];
/**
 * @export
 */
export const StealerLeaksListTwoFaStatusEnum = {
    Disabled: 'disabled',
    Enabled: 'enabled',
    None: 'none'
} as const;
export type StealerLeaksListTwoFaStatusEnum = typeof StealerLeaksListTwoFaStatusEnum[keyof typeof StealerLeaksListTwoFaStatusEnum];
/**
 * @export
 */
export const StealerLeaksListValidityEnum = {
    Invalid: 'invalid',
    New: 'new',
    Valid: 'valid'
} as const;
export type StealerLeaksListValidityEnum = typeof StealerLeaksListValidityEnum[keyof typeof StealerLeaksListValidityEnum];
